<p-dialog header="Header"
          [(visible)]="visible"
          [modal]="true"
          [closable]="false"
          [draggable]="false"
          [resizable]="false"
          [style]="{ width: '50vw', 'max-width': '95vw' }"
          [breakpoints]="{ '1024px': '90vw', '1300px': '50vw' }"
          contentStyleClass="!w-full !p-6">
  <ng-template #header>
    <div class="flex w-full flex-col gap-1">
      <label class="text-left font-bold">{{ 'session' | translate }}: {{ session.name }}</label>
      <p-divider />
    </div>
  </ng-template>

  <div class="flex w-full flex-col gap-3">
    <div class="grid w-full grid-cols-3 items-center gap-2 px-4 py-2">
      <label class="text-left text-sm font-semibold">{{ 'date' | translate }}</label>
      <label class="col-span-2">{{ session.timeStamp | date:'medium' }}</label>

      <label class="text-left text-sm font-semibold">{{ 'parameters.duration' | translate }}</label>
      <label>{{ session.duration | duration }}</label>
      <label class="text-left text-sm font-semibold">[mm:ss]</label>

      @if (session.hasReport) {
      <p-button [label]="'showReport' | translate" (click)="onShowReport()"></p-button>
      }
    </div>

    @if(loading) {
    <div class="flex h-48 w-full items-center justify-center gap-3 p-4">
      <strong class="text-surface-700 dark:text-surface-300">{{ 'loading' | translate }}</strong>
      <p-progress-spinner aria-label="Caricamento" [style]="{ width: '4rem', height: '4rem' }" />
    </div>
    } @else {
    <p-tabs class="w-full"
            [(value)]="tabsId">
      <p-tablist>
        @for (ex of exercises; track ex.exerciseId) {
        <p-tab [value]="ex.exerciseId">{{ ex.name }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels class="!pt4 w-full">
        @for (ex of exercises; track ex.exerciseId) {
        <p-tabpanel [value]="ex.exerciseId">
          <div class="flex w-full min-w-full flex-row items-stretch gap-6">
            <div class="grid w-1/2 grid-cols-3 content-start items-center gap-x-2 gap-y-3 px-2 py-2">
              <label class="text-left text-sm font-semibold">{{ 'date' | translate }}</label>
              <label class="col-span-2 text-sm">{{ ex.startDate | date:'medium' }}</label>

              <label class="text-left text-sm font-semibold">{{ 'parameters.duration' | translate }}</label>
              <label class="text-sm">{{ ex.duration | duration }}</label>
              <label class="text-left text-sm font-semibold">[mm:ss]</label>

              <label class="text-left text-sm font-semibold">{{ 'repetitions' | translate }}</label>
              <label class="col-span-2 text-sm">{{ ex.repetitionQuantity }}</label>

              <label class="text-left text-sm font-semibold">{{ 'notes' | translate }}</label>
              <p class="col-span-2 text-sm" [innerHTML]="ex.notes"></p>
            </div>

            <p-divider layout="vertical" class="h-full" />

            <div class="w-1/2 min-w-0">
              <p-table [value]="ex.measures"
                       size="small"
                       [scrollable]="true" scrollHeight="flex"
                       stripedRows
                       class="block w-full">
                <ng-template #header>
                  <tr>
                    <th>{{ 'description' | translate }}</th>
                    <th>{{ 'value' | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template #body let-measure>
                  <tr>
                    <td>{{ 'parameters.' + measure.measure | translate }}</td>
                    <td>{{ measure.value }}</td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabpanel>
        }
      </p-tabpanels>    </p-tabs>
    }
  </div>

  <ng-template #footer>
    <p-button [label]="'primeng.completed' | translate"
              (click)="onClose()" />
  </ng-template>
</p-dialog>
